import { render, staticRenderFns } from "./detailsurattugas.vue?vue&type=template&id=4726c8f4&"
import script from "./detailsurattugas.vue?vue&type=script&lang=js&"
export * from "./detailsurattugas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports